<template>
    <div :class="{ 'ls-brand-logo': true, lg: size == 'lg' }">
        <img v-if="hasBrandLogo" class="logo" :src="require('@/assets/brands/' + brand + '.svg')" />
        <span v-if="showName" class="name">{{ brandName }}</span>
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsBrand',
    props: {
        brand: VueTypes.string.isRequired,
        showName: VueTypes.bool.isRequired,
        size: VueTypes.string,
    },
    computed: {
        brandName() {
            switch (this.brand) {
                case 'lawnstarter':
                    return 'LawnStarter';
                case 'lawnlove':
                    return 'Lawn Love';
                case 'homegnome':
                    return 'HomeGnome';
                default:
                    return 'Unknown';
            }
        },
        hasBrandLogo() {
            return this.brandName !== 'Unknown';
        },
    },
    methods: {},
};
</script>

<style lang="scss">
.ls-brand-logo {
    display: inline-block;
    white-space: nowrap;
    font-size: 14px;

    .logo {
        display: inline-block;
        font-size: inherit;
        width: 25px;
        height: 25px;
    }

    .name {
        margin-left: 4px;
        position: relative;
        font-size: inherit;
        top: -8px;
    }

    &.lg {
        font-size: 20px;
        .logo {
            width: 35px;
            height: 35px;
        }
        .name {
            top: -10px;
        }
    }
}
</style>
